import React from 'react';
import ReactDOM from 'react-dom';
import { store } from '../../../../store/store';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import LaboratoryRequestListWrapper from './LaboratoryResultsListWrapper';

loadDOMComponent({
	selector: 'react-laboratory-results-list',
	callback: ({ container }: any) => {
		const patientId = container.getAttribute('patientId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider>
					<AclContextProvider>
						<LaboratoryRequestListWrapper patientId={patientId} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
